import React from "react"

import ChangeAPISection from "./ChangeAPISection"

const ChangeAPI = () => (
  <div>
    <span>
      Experimental - might not work everywhere, can be overriden in url (uses Cookies if enabled)
    </span>
    <div>
      <ChangeAPISection title="apiUrl (Search, Places)" apiType="apiUrl" />
      <ChangeAPISection title="metaApiUrl (Search - other providers)" apiType="metaApiUrl" />
      <ChangeAPISection title="bookingApiUrl (Booking, manage)" apiType="bookingApiUrl" />
      <ChangeAPISection title="PICI api url (Booking)" apiType="piciApiUrl" />
      <ChangeAPISection title="mmbApiUrl (Mambo, new manage calls)" apiType="mmbApiUrl" />
      <ChangeAPISection title="authApiUrl (Auth)" apiType="authApiUrl" />
      <ChangeAPISection title="locationsApiUrl (Locations)" apiType="locationsApiUrl" />
      <ChangeAPISection title="Umbrella (Search)" apiType="umbrellaUrl" />
      <ChangeAPISection title="GraphQL (Multiple services)" apiType="graphqlApiUrl" />
    </div>
  </div>
)

export default ChangeAPI
